import { render } from "./DirectionInitial.vue?vue&type=template&id=10e97f22"
import script from "./DirectionInitial.vue?vue&type=script&lang=js"
export * from "./DirectionInitial.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__